Object.defineProperty(exports, "__esModule", { value: true });
exports.breakpointsPreset = void 0;
exports.breakpointsPreset = {
    breakpoints: ['48em', '64em', '80em', '90.0625em'],
};
//# sourceMappingURL=breakpoints-preset.js.map